<template>
  <div class="mine page">
    <div class="wrapper">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <div class="mine-body">
          <section class="hero">
            <div class="hero-actions">
              <button class="icon-btn" type="button" @click="showSetting">
                <van-icon name="setting-o" />
              </button>
              <button class="icon-btn logout-btn" type="button" @click="loginout">
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                  <polyline points="16 17 21 12 16 7" />
                  <line x1="21" y1="12" x2="9" y2="12" />
                </svg>
              </button>
            </div>

            <div class="user-card" @click="doLogin">
              <img :src="avatarSrc" :alt="$t('minePage.avatar_alt')" class="avatar" />

              <div class="user-main">
                <div class="name-row">
                  <span class="username">{{ displayUsername }}</span>
                  <img v-if="showVipBadge" src="/img/milikku/vip.png" :alt="$t('minePage.vip_alt')" class="vip-badge" />
                </div>

                <div class="progress-track">
                  <div class="progress-fill" :style="{ width: progressWidth }"></div>
                </div>
              </div>
            </div>
          </section>

          <section class="stats-card">
            <div class="stat-item">
              <div class="stat-label">{{ $t("minePage.account_point") }}</div>
              <div class="stat-value">{{ accountPoint }}</div>
            </div>
            <div class="stat-divider"></div>
            <div class="stat-item">
              <div class="stat-label">{{ $t("minePage.trust") }}</div>
              <div class="stat-value">{{ trustValue }}</div>
            </div>
            <div class="stat-divider"></div>
            <div class="stat-item">
              <div class="stat-label">{{ $t("minePage.number_of_film") }}</div>
              <div class="stat-value">{{ filmCount }}</div>
            </div>
          </section>

          <section class="content-panel">
            <div class="menu-list">
              <button
                v-for="item in menuItems"
                :key="item.key"
                type="button"
                class="menu-item"
                @click="handleMenu(item)"
              >
                <div class="menu-left">
                  <img :src="item.icon" :alt="item.label" class="menu-icon" />
                  <span class="menu-label">{{ item.label }}</span>
                </div>
              </button>
            </div>
          </section>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: {},
      kefu: "",
      isLoading: false,
    };
  },
  computed: {
    menuItems() {
      return [
        {
          key: "withdraw",
          label: this.$t("minePage.menu.withdraw_money"),
          icon: "/img/milikku/zijin.png",
          action: "doWithdrawal",
        },
        {
          key: "deposit",
          label: this.$t("minePage.menu.deposit_money"),
          icon: "/img/milikku/txzx.png",
          route: "/Recharge",
        },
        {
          key: "info",
          label: this.$t("minePage.menu.personal_information"),
          icon: "/img/milikku/zhzl.png",
          route: "/Infomation",
        },
        {
          key: "withdraw-record",
          label: this.$t("minePage.menu.withdrawal_records"),
          icon: "/img/milikku/duihuan.png",
          route: "/WithdrawRecord",
        },
        {
          key: "recharge-record",
          label: this.$t("minePage.menu.deposit_history"),
          icon: "/img/milikku/jifen.png",
          route: "/RechargeRecord",
        },
        {
          key: "game-record",
          label: this.$t("minePage.menu.voting_history"),
          icon: "/img/milikku/toupiao.png",
          route: "/GameRecord",
        },
        {
          key: "notice",
          label: this.$t("minePage.menu.system_notifications"),
          icon: "/img/milikku/gonggao1.png",
          action: "toNotice",
        },
      ];
    },
    displayUsername() {
      return this.userInfo.username || this.$t("setting.log_reg");
    },
    showVipBadge() {
      return !!localStorage.getItem("token");
    },
    avatarSrc() {
      return "/img/milikku/logo.png";
    },
    accountPoint() {
      const value = Number(this.userInfo.money || 0);
      return Number.isFinite(value) ? value.toFixed(2) : "0.00";
    },
    trustValue() {
      return this.userInfo.score || 0;
    },
    filmCount() {
      const rawVideo = this.userInfo.pvideo || this.userInfo.video || "";
      if (!rawVideo) {
        return 0;
      }
      if (Array.isArray(rawVideo)) {
        return rawVideo.filter(Boolean).length;
      }
      return String(rawVideo)
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean).length;
    },
    progressWidth() {
      const trust = Number(this.trustValue) || 0;
      const normalized = Math.max(20, Math.min(100, trust));
      return `${normalized}%`;
    },
  },
  methods: {
    normalizeAssetPath(path) {
      if (!path) {
        return "";
      }
      if (/^https?:\/\//.test(path) || path.startsWith("/")) {
        return path;
      }
      return `/${path.replace(/^\.?\//, "")}`;
    },
    handleMenu(item) {
      if (item.route) {
        this.$router.push({ path: item.route });
        return;
      }
      if (item.action && typeof this[item.action] === "function") {
        this[item.action]();
      }
    },
    refresh() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
        if (localStorage.getItem("token")) {
          this.$toast(this.$t("reservation.refresh"));
        } else {
          this.$router.push({ path: "/Login" });
        }
      }, 500);
    },
    getBasicConfig() {
      this.$http({
        method: "get",
        url: "sys_config",
      }).then((res) => {
        this.kefu = res.data.kefu;
      });
    },
    exit() {
      this.$toast(this.$t("my.finish_task"));
    },
    showSetting() {
      if (localStorage.getItem("token")) {
        this.$router.push({ path: "/Setting" });
      } else {
        this.$router.push({ path: "/Login" });
      }
    },
    toNotice() {
      if (localStorage.getItem("token")) {
        this.$router.push({ path: "/Notice" });
      } else {
        this.$router.push({ path: "/Login" });
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        if (localStorage.getItem("token")) {
          this.getUserInfo();
          this.$toast(this.$t("reservation.refresh"));
        } else {
          this.$router.push({ path: "/Login" });
        }
      }, 500);
    },
    doLogin() {
      if (localStorage.getItem("token")) {
        this.$router.push({ path: "/Infomation" });
      } else {
        this.$router.push({ path: "/Login" });
      }
    },
    doPay() {
      this.$router.push({
        name: "Recharge",
        params: {
          balance: this.userInfo.money,
        },
      });
    },
    doWithdrawal() {
      this.$http({
        method: "get",
        url: "user_get_bank",
      }).then((res) => {
        if (res.data.is_bank) {
          this.$router.push({ path: "/Withdraw" });
        } else {
          this.$router.push({ path: "/Setbank" });
          this.$toast.fail(this.$t("setting.set_bank"));
        }
      });
    },
    toService() {
      if (this.$store.getters.getBaseInfo.iskefu == 1) {
        this.$router.push("Withdraw");
      } else {
        this.$toast.fail(this.$t("setting.forbid"));
      }
    },
    shuaxin() {
      this.getUserInfo();
      this.$toast(this.$t("reservation.refresh"));
    },
    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
          if (this.userInfo.status !== 1) {
            this.$toast(this.$t("video.account_out"));
            localStorage.clear();
            this.$router.push({ path: "/Login" });
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    toServicePage() {
      window.location.href = this.kefu;
    },
    loginout() {
      localStorage.clear();
      this.$router.push({ path: "/Login" });
    },
  },
  created() {
    this.getBasicConfig();
    if (localStorage.getItem("token")) {
      this.getUserInfo();
    } else {
      this.userInfo = {
        username: this.$t("setting.log_reg"),
        money: "0.00",
        score: 0,
      };
    }
  },
};
</script>

<style scoped>
.page {
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  background: #f3f3f3;
}

.mine {
  width: 100%;
  min-height: 100%;
  background: #f3f3f3;
}

.wrapper {
  position: absolute;
  inset: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.mine-body {
  min-height: 100%;
  padding-bottom: 188px;
  background: #f3f3f3;
}

.hero {
  position: relative;
  z-index: 1;
  padding: 34px 36px 162px;
  background: linear-gradient(90deg, #6667e8 0%, #5d63e1 100%);
}

.hero-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.icon-btn {
  width: 52px;
  height: 52px;
  padding: 0;
  border: none;
  background: transparent;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-btn .van-icon {
  font-size: 40px;
}

.logout-btn svg {
  width: 34px;
  height: 34px;
  stroke: #fff;
  stroke-width: 2;
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.user-card {
  display: flex;
  align-items: center;
  margin-top: 34px;
}

.avatar {
  width: 108px;
  height: 108px;
  flex-shrink: 0;
  border: 4px solid rgba(255, 255, 255, 0.95);
  border-radius: 50%;
  object-fit: cover;
  background: #fff;
}

.user-main {
  flex: 1;
  min-width: 0;
  margin-left: 24px;
}

.name-row {
  display: flex;
  align-items: center;
  gap: 14px;
}

.username {
  max-width: 100%;
  color: #fff;
  font-size: 40px;
  line-height: 50px;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.vip-badge {
  width: 132px;
  height: 40px;
  object-fit: contain;
}

.progress-track {
  width: 270px;
  max-width: 100%;
  height: 14px;
  margin-top: 18px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.35);
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  border-radius: inherit;
  background: rgba(255, 255, 255, 0.98);
}

.stats-card {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: stretch;
  width: calc(100% - 24px);
  margin: -82px auto 28px;
  padding: 28px 0 30px;
  border-radius: 24px;
  background: #fff;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.08);
}

.stat-item {
  flex: 1;
  text-align: center;
}

.stat-label {
  color: #726456;
  font-size: 20px;
  line-height: 30px;
}

.stat-value {
  margin-top: 12px;
  color: #595de2;
  font-size: 30px;
  line-height: 38px;
  font-weight: 700;
}

.stat-divider {
  width: 1px;
  margin: 8px 0;
  background: #e5e5e5;
}

.content-panel {
  position: relative;
  z-index: 2;
  background: #f3f3f3;
}

.menu-list {
  background: #fff;
}

.menu-item {
  width: 100%;
  min-height: 106px;
  padding: 0 34px 0 40px;
  border: none;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.menu-left {
  display: flex;
  align-items: center;
  min-width: 0;
}

.menu-icon {
  width: 46px;
  height: 46px;
  object-fit: contain;
  flex-shrink: 0;
}

.menu-label {
  margin-left: 22px;
  color: #161616;
  font-size: 26px;
  line-height: 36px;
  text-align: left;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #fff;
  font-size: 34px;
}
</style>
